
const alphariddims = {
    A: {
      pattern: [7, 4],
      alphariddim: [1,2,3,3],
      offset: 0,
      bpm: 90,
    },
    E: {
      pattern: [7, 4],
      alphariddim: [1,3,3,3],
      offset: 0,
      bpm: 90,
    },
    I: {
      pattern: [7, 4],
      alphariddim: [1,1,3,3],
      offset: 0,
      bpm: 90,
    },
    O: {
      pattern: [7, 4],
      alphariddim: [2,2,2,3],
      offset: 0,
      bpm: 90,
    },
    U: {
      pattern: [7, 4],
      alphariddim: [1,1,2,3],
      offset: 0,
      bpm: 90,
    },
  
    B: {
      pattern: [9, 4],
      alphariddim: [2,1,1,1],
      offset: 0,
      bpm: 90,
    },
    C: {
      pattern: [9, 4],
      alphariddim: [2,1,2,1],
      offset: 0,
      bpm: 90,
    },
    D: {
      pattern: [9, 4],
      alphariddim: [2,1,1,3],
      offset: 0,
      bpm: 90,
    },
    F: {
      pattern: [9, 4],
      alphariddim: [1,1,2,1],
      offset: 0,
      bpm: 90,
    },
    G: {
      pattern: [9, 4],
      alphariddim: [2,2,1,3],
      offset: 0,
      bpm: 90,
    },
    H: {
      pattern: [9, 4],
      alphariddim: [1,1,1,1],
      offset: 0,
      bpm: 90,
    },
    J: {
      pattern: [9, 4],
      alphariddim: [1,2,2,2],
      offset: 0,
      bpm: 90,
    },
    K: {
      pattern: [9, 4],
      alphariddim: [2,1,2,3],
      offset: 0,
      bpm: 90,
    },
    L: {
      pattern: [9, 4],
      alphariddim: [1,2,1,1],
      offset: 0,
      bpm: 90,
    },
    M: {
      pattern: [9, 4],
      alphariddim: [2,2,3,3],
      offset: 0,
      bpm: 90,
    },
    N: {
      pattern: [9, 4],
      alphariddim: [2,1,3,3],
      offset: 0,
      bpm: 90,
    },
    P: {
      pattern: [9, 4],
      alphariddim: [1,2,1,2],
      offset: 0,
      bpm: 90,
    },
    Q: {
      pattern: [9, 4],
      alphariddim: [2,2,1,2],
      offset: 0,
      bpm: 90,
    },
    R: {
      pattern: [9, 4],
      alphariddim: [1,2,1,3],
      offset: 0,
      bpm: 90,
    },
    S: {
      pattern: [9, 4],
      alphariddim: [1,1,1,3],
      offset: 0,
      bpm: 90,
    },
    T: {
      pattern: [9, 4],
      alphariddim: [2,3,3,3],
      offset: 0,
      bpm: 90,
    },
    W: {
      pattern: [9, 4],
      alphariddim: [1,2,2,3],
      offset: 0,
      bpm: 90,
    },
    V: {
      pattern: [9, 4],
      alphariddim: [1,1,1,2],
      offset: 0,
      bpm: 90,
    },
    X: {
      pattern: [9, 4],
      alphariddim: [2,1,1,2],
      offset: 0,
      bpm: 90,
    },
    Y: {
      pattern: [9, 4],
      alphariddim: [2,1,2,2],
      offset: 0,
      bpm: 90,
    },
    Z: {
      pattern: [9, 4],
      alphariddim: [2,2,1,1],
      offset: 0,
      bpm: 90,
    },
   
    // Add more sequences as needed
  };

export default alphariddims